import React from 'react';
import { CopyLinkRow, Dialog, T } from '@colonist/ui';
import styles from './ReferFriendsDialog.module.scss';
export const ReferFriendsDialog = ({ open, onClose, rewardImageUrl, itemCategoryName, invitesLeft, referralLink, onCopyLink })=>{
    const bodyText = {
        key: 'strings:storePage.sections.referral.popup.body',
        options: {
            count: invitesLeft,
            itemCategory: itemCategoryName
        }
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: rewardImageUrl,
            alt: 'strings:imgAlts.Gift'
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:storePage.sections.referral.popup.title'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: bodyText
    })), /*#__PURE__*/ React.createElement(CopyLinkRow, {
        link: referralLink,
        onCopyLink: onCopyLink
    }))));
};
